import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { Login } from '../pages/Login';

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  tab: z.enum(['email-link', 'password']).optional().default('email-link'),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: ({ context, search }) => {
    // If user is already authenticated, redirect to home or the redirect URL
    if (context.auth.isAuthenticated) {
      throw redirect({
        to: search.redirect || '/',
      });
    }
  },
  component: Login,
});

